import { render } from "./GameScreen.vue?vue&type=template&id=ca6beaec&scoped=true"
import script from "./GameScreen.vue?vue&type=script&lang=js"
export * from "./GameScreen.vue?vue&type=script&lang=js"

import "./GameScreen.vue?vue&type=style&index=0&id=ca6beaec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6beaec"]])

export default __exports__